module.exports = __webpack_public_path__ + "5d95624a6f69e60f06710abc803f6e0f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/space.png
// module id = 3183
// module chunks = 0